import { toast } from "sonner";
import { ToastCard } from "../components/ToastCard";

const DURATION = {
  success: 3600,
  info: 4000,
  warning: 4500,
  error: 5600,
};

function show(tone, message, options = {}) {
  const duration = options.duration ?? DURATION[tone] ?? 4200;

  return toast.custom(
    (id) => (
      <ToastCard
        tone={tone}
        message={message}
        durationMs={duration}
        onDismiss={() => toast.dismiss(id)}
      />
    ),
    {
      duration,
      position: "top-right",
      className: "cotify-toast-host",
      ...options,
    },
  );
}

/**
 * Feedback no bloqueante para la app de tasación.
 * Cupo agotado → CreditsBlockedModal (no toast).
 */
export const notify = {
  success: (message, options) => show("success", message, options),
  error: (message, options) => show("error", message, options),
  warning: (message, options) => show("warning", message, options),
  info: (message, options) => show("info", message, options),
};

export default notify;
